import { render, staticRenderFns } from "./ICPCTab.vue?vue&type=template&id=b516d04e"
import script from "./ICPCTab.vue?vue&type=script&lang=js"
export * from "./ICPCTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports